<template>
  <div v-if="salaryOriginal !== null"
       class="vacancy-card-new__salary">
    <div class="vacancy-card-new__salary-top">
      {{ salary }}
      <sub>
        {{ currentCurrency }}<template v-if="salaryPerType">/</template>{{ salaryPerType }}
      </sub>
    </div>

    <div class="vacancy-card-new__salary-bottom">
      ({{ salaryOriginal }}
      {{ salaryCurrencyOriginal }}<template v-if="salaryCurrencyOriginal && salaryPerType">/</template>{{ salaryPerType }})
    </div>

    <div class="vacancy-card-new__salary-info">
      <BaseSvg name="ico-info-2"
               width="1.1rem"
               height="1.1rem"/>

      <div class="vacancy-card-new__salary-info-tooltip">
        <div class="text">
          <p>{{ $tVacancy('Salary shown is net. That is, what the employee will receive in his hands') }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import formatNumber from '@/helpers/formatNumber'

  export default {
    name: 'VacancyCardInfoSalary',
    props: {
      section: Object
    },
    computed: {
      salary() {
        if (this.salaryOriginal === null) return null
        const salary = this.section.salary_in_selected_currency
        return this.getSalary(salary)
      },

      salaryOriginal() {
        const salary = this.section.salary
        return this.getSalary(salary)
      },

      salaryCurrencyOriginal() {
        const currency = this.section.currency
        return currency ? currency.symbol : null
      },

      salaryPerType() {
        const type = this.section.salary_type
        return type ? type.name : null
      },

      currentCurrency() {
        let currentCurrency = this.$store.state.currentCurrency
        if (currentCurrency.currency === 'ALL') {
          currentCurrency = this.section.currency
        }

        return currentCurrency.symbol
      },
    },
    methods: {
      getSalary(salary) {
        if (Array.isArray(salary)) {
          if (isNaN(parseFloat(salary[0])) || isNaN(parseFloat(salary[1]))) {
            return null
          }

          return salary[0] === salary[1]
              ? formatNumber(salary[0])
              : `${formatNumber(salary[0])} - ${formatNumber(salary[1])}`
        }

        return isNaN(parseFloat(salary)) ? null : formatNumber(salary)
      }
    }
  }
</script>

<style lang="less">

</style>
